import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { NumberParam } from 'serialize-query-params';
import { useSyncedSearchArgs } from '@app/common/navigation/use-synced-search-args';
import { LicenseHistoryTable } from '@modules/license';
import { PageTitle } from '@common/page-layout/page-title';
const tsTypeToQuerySchema = {
    page: NumberParam
};
function validateSessionsFilter(parsed) {
    return {
        page: parsed.page && parsed.page > 0 ? parsed.page : 1
    };
}
export function LicenseHistoryPage() {
    const [urlParams, setUrlParams] = useSyncedSearchArgs(tsTypeToQuerySchema, validateSessionsFilter);
    return (_jsxs(_Fragment, { children: [_jsx(PageTitle, { title: "License History", breadcrumbs: [
                    { title: 'Configuration' },
                    { title: 'License & Activation', href: '/configuration/license-activation' }
                ] }), _jsx(LicenseHistoryTable, { params: { ...urlParams }, onParamChange: setUrlParams })] }));
}
